var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4.375C3 4.02982 3.27982 3.75 3.625 3.75H17.375C17.7202 3.75 18 4.02982 18 4.375C18 4.72018 17.7202 5 17.375 5H3.625C3.27982 5 3 4.72018 3 4.375Z",
    fill: "#EC1C24"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 1.875C6.75 1.52982 7.02982 1.25 7.375 1.25H13.625C13.9702 1.25 14.25 1.52982 14.25 1.875C14.25 2.22018 13.9702 2.5 13.625 2.5H7.375C7.02982 2.5 6.75 2.22018 6.75 1.875Z",
    fill: "#EC1C24"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.875 3.75C5.22018 3.75 5.5 4.02982 5.5 4.375V16.25H15.5V4.375C15.5 4.02982 15.7798 3.75 16.125 3.75C16.4702 3.75 16.75 4.02982 16.75 4.375V16.25C16.75 16.5815 16.6183 16.8995 16.3839 17.1339C16.1495 17.3683 15.8315 17.5 15.5 17.5H5.5C5.16848 17.5 4.85054 17.3683 4.61612 17.1339C4.3817 16.8995 4.25 16.5815 4.25 16.25V4.375C4.25 4.02982 4.52982 3.75 4.875 3.75Z",
    fill: "#EC1C24"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.80758c113468ad939798d8dbf8fdd733.svg";
export { ForwardRef as ReactComponent };